import { Card, Row, Col, Alert } from 'react-bootstrap';
import { Appointment } from '@/types/appointment.tsx';
import { DraggableAppointment } from './DraggableAppointment';
import { format, isSameDay, compareAsc } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useMemo } from 'react';

interface ListViewProps {
  appointments: Appointment[];
}

export function ListView({ appointments }: ListViewProps) {
  const groupedAppointments = useMemo(() => {
    const sorted = [...appointments].sort((a, b) => compareAsc(a.date, b.date));
    
    const groups: { date: Date; appointments: Appointment[] }[] = [];
    
    sorted.forEach((apt) => {
      const existingGroup = groups.find((g) => isSameDay(g.date, apt.date));
      if (existingGroup) {
        existingGroup.appointments.push(apt);
      } else {
        groups.push({ date: apt.date, appointments: [apt] });
      }
    });

    return groups;
  }, [appointments]);

  if (appointments.length === 0) {
    return (
      <Alert variant="info" className="text-center py-5 animate-fade-in">
        <Alert.Heading>Nenhum agendamento encontrado</Alert.Heading>
        <p className="mb-0">Tente ajustar os filtros para ver mais resultados</p>
      </Alert>
    );
  }

  return (
    <div className="animate-fade-in">
      {groupedAppointments.map((group) => (
        <Card key={group.date.toISOString()} className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <div className="d-flex align-items-center gap-2">
              <span
                className="rounded-circle bg-primary"
                style={{ width: '8px', height: '8px' }}
              />
              <h6 className="mb-0 fw-semibold">
                {format(group.date, "EEEE, dd 'de' MMMM", { locale: ptBR })}
              </h6>
              <small className="text-muted">({group.appointments.length})</small>
            </div>
          </Card.Header>
          <Card.Body>
            <Row className="g-3">
              {group.appointments.map((apt) => (
                <Col key={apt.id} xs={12} sm={6} lg={4}>
                  <DraggableAppointment appointment={apt} />
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}
